export default "__VITE_ASSET__Fw4Dkt14__"